module.exports = __webpack_public_path__ + "static/prestashop_applepay-0114d92effb02e3205b9470757bfbab2.svg";